import { createFileRoute } from '@tanstack/react-router';
import { SandboxPage } from '../sandbox-page';
export const Route = createFileRoute('/academy/')({ component: () => <SandboxPage academy /> });
